import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_028",
  "use": "icon-su_028-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-su_028\"><defs><style>#icon-su_028 .cls-1{fill:none;opacity:0;}#icon-su_028 .cls-2{fill:#5ab3a0;}</style></defs><g id=\"icon-su_028_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_028_icon\"><rect class=\"cls-1\" width=\"20\" height=\"20\" /><circle class=\"cls-2\" cx=\"10\" cy=\"10\" r=\"5\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol